module.exports = __webpack_public_path__ + "img/nav-bg.7bea8fbc.svg";